var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card-text',[_c('read-more',{attrs:{"more-str":this.$t('read_more_message'),"less-str":this.$t('read_less_message'),"text":_vm.data.payload.text,"max-chars":100,"link":"#"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }